// extracted by mini-css-extract-plugin
module.exports = {"label":"SectionLabel_label__2kC03","info":"SectionLabel_info__cyq_M"};